const STORAGE_PREFIX = "csv-table-preview:";

/** Exact bytes offered by the preview's download button. */
export interface CsvTablePreviewDownload {
  filename: string;
  contentBase64: string;
  mimeType?: string;
}

export interface CsvTablePreviewFile {
  /** Shown in the file picker when a preview holds several files. */
  label?: string;
  rows: string[][];
  download?: CsvTablePreviewDownload;
}

export interface StoredCsvTablePreview {
  title: string;
  files: CsvTablePreviewFile[];
}

/** Persist CSV table payloads for utility-window handoff (keyed by id). */
export function putCsvTablePreview(payload: StoredCsvTablePreview): string {
  const contentId = crypto.randomUUID();
  sessionStorage.setItem(
    `${STORAGE_PREFIX}${contentId}`,
    JSON.stringify(payload),
  );
  return contentId;
}

export function getCsvTablePreview(contentId: string): StoredCsvTablePreview | null {
  const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${contentId}`);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<StoredCsvTablePreview> & { rows?: string[][] };
    if (Array.isArray(parsed.files)) return { title: parsed.title ?? "", files: parsed.files };
    if (Array.isArray(parsed.rows)) return { title: parsed.title ?? "", files: [{ rows: parsed.rows }] };
    return null;
  } catch {
    return null;
  }
}

export function removeCsvTablePreview(contentId: string): void {
  sessionStorage.removeItem(`${STORAGE_PREFIX}${contentId}`);
}
